<template>
  <v-dialog v-model="dialogValue" persistent max-width="290">
    <v-card>
      <v-card-title class="text-primary text-h5">
        {{ dialogTitle }}
      </v-card-title>
      <v-card-text class="text-primary">
        {{ dialogConfirm }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="rounded-2"
          color="primary"
          variant="flat"
          @click="dialogValue = false"
        >
          <div
            class="text-subtitle-2 text-white text-truncate font-weight-bold px-3"
          >
            Cancel
          </div>
        </v-btn>
        <v-btn
          class="rounded-2"
          color="warning"
          variant="flat"
          :loading="loadingDelete"
          :disabled="loadingDelete"
          @click="handleDelete"
        >
          <div
            class="text-subtitle-2 text-white text-truncate font-weight-bold px-3"
          >
            Delete
          </div>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/Core.Service.Domain/Controls/Thermostats/API';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ConfirmDialogDeleteThermostat',

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    thermostatInfo: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loadingDelete: false,
    };
  },

  computed: {
    ...mapGetters({
      defaultSite: 'session/defaultSite',
    }),

    dialogValue: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      },
    },

    dialogTitle() {
      return `Delete this ${this.$route.meta.toolTip}?`;
    },

    dialogConfirm() {
      return `Are you sure you want to delete ${this.thermostatInfo.controlInfo.friendlyName} and its associated data? Deleting a control cannot be undone.`;
    },
  },

  methods: {
    ...mapActions({
      getControlsBySite: 'ControlsStore/getControlsBySite',
    }),

    async handleDelete() {
      try {
        const { controlId } = this.thermostatInfo;
        this.loadingDelete = true;
        await API.deleteThermostat(controlId);
        this.setDefaultSiteFromControlsDomain();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    setDefaultSiteFromControlsDomain() {
      const { controlTypeName } = this.thermostatInfo.controlInfo;
      this.getControlsBySite({
        selectedSite: this.defaultSite,
        controlTypeName,
      }).then(() => {
        this.$emit('delete-thermostat');
        this.dialogValue = false;
        this.loadingDelete = false;
      });
    },
  },
};
</script>
